<dashboardnav>

  <cradua-state
  [countries]="countries$ | async"
  [states]="states$ | async"

  (changeEmit)="onSubmitState($event)"
  (deleteEvent)="onDeleteState($event)"
  *ngIf="
  !(isLoadingCountry$ | async ) &&
  !(isLoadingState$ | async )
  "
  >
</cradua-state>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingCountry$ | async ) ||
  (isLoadingState$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
